/**
 * Dois ajustes na barra de comunicados:
 *
 * 1. Publica a altura real da barra fixa como --base-announcement-height.
 *    O header sticky do Dawn gruda em top:0 e passaria por baixo da barra. O
 *    CSS desloca o header por essa variável; aqui só medimos, para que altura
 *    de fonte, padding e quebra de linha em telas estreitas sejam respeitados
 *    sem número mágico.
 *
 * 2. Mantém a rotação das mensagens sob prefers-reduced-motion.
 */

/* 1. Altura da barra fixa -------------------------------------------------- */

(() => {
  const bar = document.querySelector('.base-announcement--sticky');
  if (!bar) return;

  const root = document.documentElement;

  const publishHeight = () => {
    root.style.setProperty('--base-announcement-height', `${Math.round(bar.offsetHeight)}px`);
  };

  publishHeight();

  if ('ResizeObserver' in window) {
    new ResizeObserver(publishHeight).observe(bar);
  } else {
    window.addEventListener('resize', publishHeight, { passive: true });
  }

  // No editor de tema a barra é re-renderizada a cada mudança de setting.
  document.addEventListener('shopify:section:load', publishHeight);
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('.base-announcement--sticky')) {
      root.style.removeProperty('--base-announcement-height');
    }
  });
})();

/* 2. Rotação automática ---------------------------------------------------- */

(() => {
  /**
   * O Dawn trata o carrossel da barra como decoração: com "reduzir movimento"
   * ligado no sistema operacional ele nunca chama play(), e a barra congela na
   * primeira mensagem. Só que aqui a mensagem é conteúdo — frete, cupom, prazo.
   * A regra da casa é desligar reveal, não conteúdo.
   *
   * Em vez de forkar o <slideshow-component>, trocamos só a checagem que o
   * Dawn consulta. Pausa no hover, no foco e ao clicar na seta continuam
   * valendo, que é o que de fato dá controle a quem lê devagar.
   */
  const neutralizeReducedMotion = (component) => {
    component.reducedMotion = { matches: false, addEventListener() {} };
  };

  const startAutoplay = () => {
    document.querySelectorAll('.base-announcement slideshow-component').forEach((component) => {
      const slider = component.querySelector('[id^="Slider-"]');
      if (!slider || slider.dataset.autoplay !== 'true') return;
      if (typeof component.play !== 'function' || !component.autoplaySpeed) return;

      neutralizeReducedMotion(component);
      component.play();
    });
  };

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  if (!reducedMotion && !designMode) return;

  customElements.whenDefined('slideshow-component').then(startAutoplay);

  // No editor, selecionar um bloco pausa o carrossel (theme-editor.js) e o
  // deselect só retoma quando existe botão de play — que a barra não tem.
  document.addEventListener('shopify:section:load', () => {
    customElements.whenDefined('slideshow-component').then(startAutoplay);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    if (!event.target.closest || !event.target.closest('.base-announcement')) return;
    startAutoplay();
  });
})();
